import { useTypedQuery } from "hooks";
import { LocationLicenseOverviewKeys } from "modules/LocationLicenseOverview/queryKeys";
import { ApiInstance } from "utils/Api";

export const useRemarkQuery = (dealer_location_id?: number) =>
  useTypedQuery({
    queryKey: LocationLicenseOverviewKeys.remark,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { dealer_location_id }, baseUrl)).data,
    refetchOnDependencies: [dealer_location_id]
  });
